import feedComparisonService from './feed-service';

import Minitable from '../../base/table/minitable';

class FeedDifferencesMinitable extends Minitable {
	constructor(props) {
		super(props);

		this.feedComparisonService = feedComparisonService;

		this.columns = [];
		this.staticColumns = [];
		this.direction = 'desc';
		this.merchantId = this.props.merchantId;
		this.fieldName = this.props.fieldName;

		if (this.props.statType === 'feed_difference_counts') {
			this.orderBy = 'difference_count';
			this.columns = [
				{
					label: 'Field Name',
					name: 'field_name',
					type: 'string',
					selected: true,
				},
				{
					label: 'Difference Count',
					name: 'difference_count',
					type: 'number',
					selected: true,
				},
				{
					label: 'Difference Percentage',
					name: 'difference_percentage',
					type: 'percent',
					selected: true,
				},
			];
		} else if (this.props.statType === 'feed_differences_by_field') {
			this.columns = [
				{
					label: 'Item ID',
					name: 'bamx_item_id',
					type: 'string',
					selected: true,
				},
				{
					label: 'Previous Feed',
					name: 'curr_value',
					type: 'string',
					selected: true,
				},
				{
					label: 'New Feed',
					name: 'temp_value',
					type: 'string',
					selected: true,
				},
			];
		}

		this.state = {
			stats: [],
			loading: false,
			showNoResult: false,

			params: {
				order_by: this.orderBy,
				direction: this.direction,
			},
		};
	}

	componentDidMount() {
		this.merchantId = this.props.merchantId;
		this.setState({loading: true});

		if (this.props.statType === 'feed_difference_counts') {
			this.queryDifferenceCounts();
		} else if (this.props.statType === 'feed_differences_by_field') {
			this.queryDifferencesByField();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.merchantId !== this.props.merchantId) {
			this.merchantId = this.props.merchantId;
			this.queryDifferenceCounts();
		}
	}

	queryDifferenceCounts() {
		this.feedComparisonService.queryFeedDifferenceCounts(
			this.merchantId
		).then(({ stats }) => {
			stats.sort((a, b) => {
				return parseFloat(b.difference_count) - parseFloat(a.difference_count);
			});

			this.setState({
				stats: stats,
				loading: false,
				showNoResult: !stats.length,
			});
		}, () => {
			this.setState({
				loading: false,
				showNoResult: true,
			});
		});
	}

	queryDifferencesByField() {
		this.feedComparisonService.queryFeedDiferencesByField(
			this.merchantId, this.fieldName
		).then(({ stats }) => {
			this.setState({
				stats: stats,
				loading: false,
				showNoResult: !stats.length,
			});
		}, () => {
			this.setState({
				loading: false,
				showNoResult: true,
			});
		});
	}
}

export default FeedDifferencesMinitable;
